export const COLORS = {
  blue: '#01A1E8',
  white: '#fff',
  orange: '#FF934F',
  red: '#D32F2F',
  midnight: '#114B5F',
  green: '#1A936F',
  background: '#fcfbfe',
};
